<button
  appButton
  name="copy-gallery-link"
  location="share-gallery-dialog"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-primary"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  [share]="shareLink()?.url"
  (onCopied)="onLinkCopied()"
  data-test-id="copy-share-link-button"
  [attr.test-share-content]="shareLink()?.url"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/link.svg" size="0-5"></app-svg>
  </div>
  <span>
    @if (canShare()) {
      Share Link
    } @else {
      Copy Link
    }
  </span>
</button>

<div class="dialog-bottom-divider"></div>

<a
  appButton
  [href]="emailHref()"
  target="_blank"
  rel="nofollow noreferrer noopener"
  name="email"
  location="share-dialog-social-footer"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray-60"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/email.svg" size="0-5"></app-svg>
  </div>
  <span>Email</span>
</a>

<a
  appButton
  [href]="facebookHref()"
  target="_blank"
  rel="nofollow noreferrer noopener"
  name="facebook"
  location="share-dialog-social-footer"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  class="facebook"
>
  <div class="svg-circle">
    <img src="/assets/icons/logo/facebook-color.svg" size="0-5" alt="" />
  </div>
  <span>Facebook</span>
</a>

<a
  appButton
  [href]="linkedinHref()"
  target="_blank"
  rel="nofollow noreferrer noopener"
  name="linkedin"
  location="share-dialog-social-footer"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  class="linkedin"
>
  <div class="svg-circle">
    <img src="/assets/icons/logo/linkedin-color.svg" size="0-5" alt="" />
  </div>
  <span>LinkedIn</span>
</a>

<a
  appButton
  [href]="telegramHref()"
  target="_blank"
  rel="nofollow noreferrer noopener"
  name="telegram"
  location="share-dialog-social-footer"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  class="telegram"
>
  <div class="svg-circle">
    <img src="/assets/icons/logo/telegram-color.svg" size="0-5" alt="" />
  </div>
  <span>Telegram</span>
</a>

<a
  appButton
  [href]="whatsappHref()"
  target="_blank"
  rel="nofollow noreferrer noopener"
  name="whatsapp"
  location="share-dialog-social-footer"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  class="whatsapp"
>
  <div class="svg-circle">
    <img src="/assets/icons/logo/whatsapp-color.svg" size="0-5" alt="" />
  </div>
  <span>WhatsApp</span>
</a>
